import store from "store"

const getAgencyConfigurations = () => {
  const state = store.getState()
  const agencyConfiguration = state?.app?.user?.info?.AgencyConfiguration

  return agencyConfiguration
}

export default getAgencyConfigurations
